import React, { useState, useEffect, useCallback } from "react";
import Swal from "sweetalert2";
import { useHistory } from "react-router";
import { Container, Grid, TextField, Button } from "@material-ui/core";
import { setpriceAPI } from "./../services/SetPriceService";

const Setting_Create_Group_Bu = () => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [group_name, setGroup_name] = useState("");
  const [bu_name, setBu_name] = useState("");

  useEffect(() => {
    document.title = `Com7 Merchandise - สร้าง Group BU`;
  }, []);

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      Swal.fire({
        title: "คุณแน่ใจ ?",
        text: `คุณต้องการเพิ่ม Group BU : ${group_name}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#56A834",
        cancelButtonColor: "#d33",
        confirmButtonText: "แน่ใจ",
        cancelButtonText: "ยังก่อน",
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(true);
          setpriceAPI
            .addGroup_BU({ group_name, bu_name })
            .then((res) => {
              if (res.status == 200) {
                Swal.fire({
                  icon: "success",
                  confirmButtonColor: "#6ab23a",
                  html: `<span class="colorWhite">${res.message}</span>`,
                  backdrop: "transparent",
                  background: "rgba(0,0,0,.75)",
                  customClass: {
                    icon: "switchZ",
                  },
                  width: "28rem",
                  timer: 3000,
                }).then((res) => {
                  history.push("/settings/group_bu");
                });
              } else {
                Swal.fire({
                  icon: "error",
                  confirmButtonColor: "#f27474",
                  html: `<span class="colorWhite">${res.message}</span>`,
                  backdrop: "transparent",
                  background: "rgba(0,0,0,.75)",
                  customClass: {
                    icon: "switch",
                  },
                  width: "28rem",
                  timer: 5000,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                confirmButtonColor: "#f27474",
                html: `<span class="colorWhite">${error.message}</span>`,
                backdrop: "transparent",
                background: "rgba(0,0,0,.75)",
                customClass: {
                  icon: "switch",
                },
                width: "28rem",
                timer: 5000,
              });
            })
            .finally(() => {
              setLoading(false);
            });
        }
      });
    },
    [group_name, bu_name]
  );

  return (
    <Container
      style={{
        padding: "20px",
        backgroundColor: "#ffffffbd",
        borderRadius: "10px",
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <h3>
            <strong>เพิ่ม Group Bu</strong>
          </h3>
        </Grid>
      </Grid>
      <Container style={{ paddingTop: "1.5rem" }}>
        <div className="row">
          <div className="pt-2 col-lg-12">
            <div className="row">
              <div className="mt-4 col-lg-12">
                <TextField
                  style={{ width: "100%" }}
                  value={group_name}
                  onChange={(event) => setGroup_name(event.target.value)}
                  label="ชื่อ Group"
                  disabled={loading}
                />
              </div>
              <div className="mt-4 col-lg-12">
                <TextField
                  style={{ width: "100%" }}
                  value={bu_name}
                  onChange={(event) => setBu_name(event.target.value)}
                  label="ชื่อ Bu"
                  disabled={loading}
                />
              </div>
              <div className="mt-4 col-12">
                <Button
                  variant="contained"
                  onClick={onSubmit}
                  disabled={!!loading || !group_name || !bu_name}
                  style={{
                    border: "2px solid transparent",
                    backgroundColor: "#6ab23a",
                    borderRadius: "5px",
                    color: "white",
                    fontSize: "16px",
                    textDecoration: "none",
                    textTransform: "capitalize",
                  }}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Container>
  );
};

export default Setting_Create_Group_Bu;
